export default __webpack_public_path__ + "static/loadingCircle-4bea8c9fef414eab06cd58d4ce209619.gif";